import { useTheme } from "@emotion/react";
import {
  Box,
  Grid,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";

function ListingDetails({ data }) {
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.up("md"));

  const getColumnCount = () => {
    if (isXsScreen) return 3;
    if (isMediumScreen) return 4;
    return 4; // Default to 4 columns for larger screens
  };

  return (
    <Stack>
      <Grid
        container
        columns={12}
        spacing={{ xs: 0, md: 5 }}
        sx={{
          width: "fit-content",
          marginInline: "auto !important",
          justifyContent: { xs: "left", md: "left" },
        }}
      >
        {(data || []).map((detail, index) => (
          <Grid item lg={4} xs={6} key={index}>
            <Box
              sx={{
                mb: { xs: 3, md: 0, display: "flex", alignContent: "center" },
              }}
            >
              <Paper
                elevation={1}
                sx={{
                  minWidth: "80%", // Adaptable a su contenedor
                  padding: { xs: 2, md: 2 }, // Espaciado interno responsivo
                  display: "flex",
                  flexDirection: "column",
                  alignItems: { xs: "center", md: "flex-start" },
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                <Typography
                  component="h3"
                  variant="h6"
                  fontSize={isMediumScreen ? "normal" : "small"}
                  sx={{
                    display: "flex",
                    whiteSpace: "nowrap",
                    alignItems: "center",
                    fontWeight: "normal",
                    textTransform: "uppercase", // Convierte el texto a mayúsculas
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: { xs: 0.5, md: 1 },
                    }}
                  >
                    <detail.icon
                      sx={{ fontSize: { xs: "medium", md: "large" } }}
                    />
                  </Box>
                  {detail.title}
                </Typography>
                <Typography
                  component="span"
                  variant="h5"
                  color="textSecondary"
                  sx={{ fontWeight: "normal" }}
                  textAlign={{ xs: "center", md: "left" }}
                >
                  {detail.value}
                </Typography>
              </Paper>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}

export default ListingDetails;
